import React from "react";
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import "./Billing.css";

class Box extends React.Component {
  render() {
    return (
      <>
        <div className="col-md-12">
          <Card>
            <Card.Header className="billing-card-header">Non GST Bank Details</Card.Header>
            <Card.Body>
              <Card.Text>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Account Number</th>
                      <th>IFSC Code</th>
                      <th>Branch</th>
                      <th>Bank Name</th>
                      <th>Type</th>
                      <th>QR Code</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>orggen</td>
                      <td>409001018715</td>
                      <td>RATN0000062</td>
                      <td>Borivali Mumbai</td>
                      <td>RBL</td>
                      <td>current</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>orggen</td>
                      <td>510101000913994</td>
                      <td>UBINO914673</td>
                      <td>Borivali Mumbai</td>
                      <td>Union Bank  (Old Corporation Bank)</td>
                      <td>current</td>
                      <td><img src="/images/qrcode.png" className="img-fluid" alt="QR Code"/></td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>

        <div className="col-md-12">
          <Card>
            <Card.Header className="billing-card-header">GST Bank Details: 18% GST Extra</Card.Header>
            <Card.Body>
              <Card.Text>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Account Number</th>
                      <th>IFSC Code</th>
                      <th>Branch</th>
                      <th>Bank Name</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Orggen Technology LLP</td>
                      <td>201001986595</td>
                      <td>INDB0000341</td>
                      <td>Borivali Mumbai</td>
                      <td>Indus Ind Bank</td>
                      <td>current</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Text>
            </Card.Body>
          </Card>
        </div>

        {/* <div className="col-md-6">
        <Card>
          <Card.Header className="billing-card-header">{props.boxtitle}</Card.Header>
          <Card.Body>
            <Card.Text>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Account Number</th>
                    <th>IFSC Code</th>
                    <th>Branch</th>
                    <th>Bank Name</th>
                    <th>Type</th>
                    <th>QR Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{props.name}</td>
                    <td>{props.accno}</td>
                    <td>{props.ifsc}</td>
                    <td>{props.branch}</td>
                    <td>{props.bankname}</td>
                    <td>{props.type}</td>
                    <td>{props.qr}</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Text>
          </Card.Body>
        </Card>
      </div> */}
      </>
    );
  }
}

export default Box;
